'use strict';

const gtm = require('../modules/google').tagManager,
    isInViewport = require('../modules/helpers/isInViewport'),
    prepareDeferedImages = require('../modules/helpers/prepareDeferedImages');

function pushProductsToDataLayer() {
    const PUSHED_CLASS = 'js-data-layer-list-pushed';
    const productTilesToPush = $('.js-hairtemple-wrapper .js-product-tile-details-content:not(.' + PUSHED_CLASS + ')');

    if (productTilesToPush.length === 0){
        $(window).off('scroll.hairtemplelanding');
        return;
    }

    productTilesToPush.each(function(_, tile) {
        const $tile = $(tile);
        if (isInViewport($tile, false)) {
            const datalayerProduct = $tile.parent().find('.js-product-tile-datalayer-product');
            if (datalayerProduct.length > 0) {
                const productData = JSON.parse(datalayerProduct.val());

                if (productData){
                    gtm.pushProductTileView(productData);
                }
            }
            $tile.addClass(PUSHED_CLASS);
        }
    });

}

function initializeEvents(){
    let timer;
    $(window).on('scroll.hairtemplelanding', function(){
        if (timer) {
            window.clearTimeout(timer);
        }
        timer = window.setTimeout(function () {
            pushProductsToDataLayer();
        }, 300);
    });

    $(document).on('click', '.js-hairtemple-wrapper a',function(){
        const datalayerProduct = $(this).parents('.js-product-tile').find('.js-product-tile-datalayer-product');
        if (datalayerProduct.length > 0) {
            const productData = JSON.parse(datalayerProduct.val());
            if (productData){
                gtm.pushProductTileClick(productData);
            }
        }
    });

    prepareDeferedImages();
}

const hairtemple = {
    init: function () {
        pushProductsToDataLayer();
        initializeEvents();
    }
};

module.exports = hairtemple;
